import React from 'react';

import { Flex } from '@lucidhq/lucidium';

import { t } from '~/utils/i18n';

import { StepLayout } from '../Steps/StepLayout';
import { ServiceCampaignDetailsForm } from './ServiceCampaignDetailsForm';

export const ServiceCampaignDetailsStep = () => {
  return (
    <StepLayout.Container>
      <StepLayout.Header
        title={t('campaignManager.campaignDetails.header.title')}
      />
      <StepLayout.Content>
        <Flex lss={{ flexDirection: 'column', flexBasis: '100%' }}>
          <ServiceCampaignDetailsForm />
        </Flex>
      </StepLayout.Content>
    </StepLayout.Container>
  );
};
